import { render } from "./ManageNavbar.vue?vue&type=template&id=feddc5ca"
import script from "./ManageNavbar.vue?vue&type=script&lang=js"
export * from "./ManageNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__